import React from 'react'
import Swal from 'sweetalert2';
import { Link,useNavigate } from "react-router-dom";
import authAxios from "../../services/Token";
import tema from "../../services/Plantilla";
import { DefaultLayout } from '../../layout/theme-customizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

  const defaultLayout = Object.keys(DefaultLayout);
  const layout = defaultLayout

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        usuario: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.usuario;
        state[e.target.name] = e.target.value;
        this.setState({ usuario: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const estado = document.getElementById('estado').value;
        const nombre = document.getElementById('nombre').value;
        const icon = document.getElementById('icon').value;
        const orden_mp = document.getElementById('orden_mp').value;
   
        var errores = [];

        if (!nombre) { errores.push("error_nombre"); }
        if (!estado) { errores.push("error_estado"); }
        if (!icon) { errores.push("error_icon"); }
        if (!orden_mp) { errores.push("error_orden_mp"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        

        authAxios.post("configuracion/", formData)
            .then((datosRespuesta) => {
                
                Swal.fire(
          
                    datosRespuesta.data.msj,
                    '',
                    'success'
                )
                window.location.href = `${process.env.PUBLIC_URL}/configuracion/lista/${layout}`;
           
                
            })
            .catch()
    }
    componentDidMount() {
        Swal.showLoading();
      

        var ide = localStorage.getItem('ide');
        
        authAxios.get("configuracion/ver/"+ide)
            .then((datosRespuesta) => {
                
                Swal.close();
                this.setState({ datosCargados: true, usuario: datosRespuesta.data, load: '' });
            })
            .catch();
        
    }
    render() {
        const { load, usuario } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR TABLA MENU</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                
                                            <input type="hidden" name="id" defaultValue={usuario.id} />
                                                <div className="col-md-3">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input  type="text" name="nombre" id="nombre" defaultValue={usuario.nombre}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOMBRE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="estado">Estado</label>
                                                    <select name="estado"
                                                        id="estado"
                                                        value={usuario.estado}
                                                        options={usuario.estado}
                                                        className={((this.verificarError("error_estado")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Estado</option>
                                                        <option value="0">Activo</option>
                                                        <option value="1">Inactivo</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado</small>
                                                </div>
                                                
                                            </div>
                                            
                                        </div>

                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                
                                            <input type="hidden" name="id" defaultValue={usuario.id} />
                                                <div className="col-md-3">
                                                    <label htmlFor="icon">icono</label>
                                                    
                                                    <select name="icon"
                                                        id="icon"
                                                        value={usuario.icon}
                                                        options={usuario.icon}
                                                        className={((this.verificarError("error_icon")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="Folder">Folder</option>
                                                        <option value="Home">Home</option>
                                                        <option value="FolderPlus">FolderPlus</option>
                                                        <option value="Cloud">Cloud</option>
                                                        <option value="FileText">FileText</option>
                                                        <option value="Server">Server</option>
                                                        <option value="Users">Users</option>
                                                        <option value="ShoppingBag">ShoppingBag</option>
                                                        <option value="List">List</option>
                                                        <option value="Mail">Mail</option>
                                                        <option value="MessageCircle">MessageCircle</option>
                                                        <option value="Monitor">Monitor</option>
                                                        <option value="Clock">Clock</option>
                                                        <option value="Calendar">Calendar</option>
                                                        <option value="CheckSquare">CheckSquare</option>
                                                        <option value="Image">Image</option>
                                                        <option value="Film">Film</option>
                                                        <option value="Radio">Radio</option>
                                                        <option value="Map">Map</option>
                                                        <option value="Edit">Edit</option>
                                                        <option value="Package">Sunrise</option>
                                                        <option value="Activity">Activity</option>
                                                        <option value="Archive">Archive</option>
                                                        <option value="BarChart">BarChart</option>
                                                        <option value="Book">Book</option>
                                                        <option value="Briefcase">Briefcase</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="orden_mp">Orden en menu</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="orden_mp" id="orden_mp" value={usuario.orden_mp}
                                                        className={((this.verificarError("error_orden_mp")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="orden" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback"></small>
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                         

                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp; Editar menu</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={`${process.env.PUBLIC_URL}/configuracion/lista/${tema}`}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;